export const initialPostScanPipeline = {
  active: false,
  currentStep: null,
  isSecondOption: false,
  trackingInput: '',
  verifyNoTracking: false,
  fieldLabel: '',
  orderNumber: '',
  messageDetail: '',
  scanSecondTime: false,
  trackingLogState: '',
  alertBoxTracking: false,
  alertBoxShipping: false,
  orderConfirmationPer: false,
  trackState: '',
  directPrintPending: null,
  // Ordered post-scan steps for this order, and what is left to run after the
  // current one. Carried here because the resume paths (prompt submit, packing
  // cam focus return) are driven by pipeline state rather than route params.
  steps: [],
  remainingSteps: []
};

export const initialBoxChampOrderState = {
  handoffVerifiedBoxIds: [],
  badgeVerifiedBoxIds: [],
  justConfirmedBoxId: null,
  sealConfirmedBoxIds: [],
  handoffMessage: '',
  handoffDismissedKey: null,
  setAsideMessage: '',
  setAsideConfirmation: false,
  optionsBoxId: null,
  pendingSubstitution: null,
  addBoxError: '',
  planError: '',
  recalculating: false,
  dimsModalOpen: false,
  completionPending: false,
  completionReleased: false,
  planOpAckedAt: null,
  sealBaseline: {orderId: null, ids: []},
  notFulfilledItems: null
};

export const initialBoxChampState = {
  ...initialBoxChampOrderState,
  catalog: [],
  catalogError: ''
};
